import api from '../..'

const destroyExternalCourse = (id: number) => {
  return api.delete(`administration/external_courses/${id}`)
}

export default destroyExternalCourse
